import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import PromoBannerEarnings from '@src/containers/EarningsManagement/BannerEarnings';
import { TAX_RATE, TAX_THRESHOLD } from '@src/constants/withdrawal';
import { getAmount } from '@src/services/withdrawal';
import CurrencyInput from '@src/new-components/Input/CurrencyInput';
import { StyledAmountWithDrawal } from './index.style';
import TaxDeduction from './TaxDeduction';

const AmountWithDrawal = ({
  amount,
  handleChangeText,
  balance = 0,
  errors,
  disabled,
  isShowDetail = false,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isVietnamese = language === 'vi';
  const [amountWithdrawal, setAmountWithdrawal] = useState(0);
  const taxDeduction = Math.round(TAX_RATE.HIGH * amountWithdrawal);
  const amountReceivedAfterTax = amountWithdrawal - taxDeduction;

  const handleChangeAmount = (e) => {
    const { value } = e.target;
    handleChangeText(value)('amount');
  };

  const handleBlurAmount = () => {
    const roundedAmount = getAmount(amount, balance);
    setAmountWithdrawal(roundedAmount);
    handleChangeText(roundedAmount)('amount');
  };

  const renderLabel = () => (
    <Typography variant="body-14-medium" color={COLOR.darkGray}>
      {t('amountWithdrawal')}
    </Typography>
  );

  const renderStartAdornment = () => (
    <Typography
      variant="body-16-medium"
      color={COLOR.indigo[80]}
      sx={{
        textDecoration: 'underline',
      }}
    >
      đ
    </Typography>
  );
  const handleClickMax = () => {
    setAmountWithdrawal(balance);
    handleChangeText(balance)('amount');
  };
  const renderEndAdornment = () => {
    if (disabled) {
      return null;
    }
    return (
      <Typography
        variant="body-14-regular"
        color={COLOR.blueV2}
        onClick={handleClickMax}
        sx={{
          cursor: 'pointer',
        }}
      >
        {t('max')}
      </Typography>
    );
  };

  useEffect(() => {
    if (disabled) {
      setAmountWithdrawal(getAmount(amount));
    }
  }, [disabled, amount]);

  return (
    <StyledAmountWithDrawal>
      {!isShowDetail && (
        <PromoBannerEarnings balance={balance} isShowActionButton={false} />
      )}
      <div>
        <CurrencyInput
          label={renderLabel()}
          name="amount"
          placeholder={t('enterAmount')}
          value={amount}
          disabled={disabled}
          onChange={handleChangeAmount}
          startAdornment={renderStartAdornment()}
          endAdornment={renderEndAdornment()}
          error={!!errors?.amount}
          onBlur={handleBlurAmount}
          thousandSeparator={isVietnamese ? '.' : ','}
          decimalSeparator={isVietnamese ? ',' : '.'}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '44px',
            },
            '& .MuiFormHelperText-root': {
              marginLeft: 0,
              marginTop: '4px',
            },
          }}
        />
        <TaxDeduction
          amountToWithdraw={amountWithdrawal}
          taxDeduction={taxDeduction}
          amountReceivedAfterTax={amountReceivedAfterTax}
          isShowTaxDeduction={amountWithdrawal >= TAX_THRESHOLD}
          isError={!!errors?.amount}
          helperText={errors?.amount}
        />
      </div>
    </StyledAmountWithDrawal>
  );
};

export default AmountWithDrawal;
